import { type RouteRecordRaw } from 'vue-router'

const requisitionsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/purchasing/requisitions',
    name: 'requisitions.index',
    component: () => import('@/modules/purchasing/requisitions/views/RequisitionsIndex.vue'),
    meta: {
      pageTitle: 'Requisitions',
      breadcrumbs: ['Requisitions']
    }
  },
  {
    path: '/purchasing/requisitions/:id',
    name: 'requisitions.show',
    component: () => import('@/modules/purchasing/requisitions/views/RequisitionsShow.vue'),
    meta: {
      pageTitle: 'Requisition',
      breadcrumbs: ['Requisitions']
    }
  },
  {
    path: '/purchasing/requisitions/create',
    name: 'requisitions.create',
    component: () => import('@/modules/purchasing/requisitions/views/RequisitionsEdit.vue'),
    meta: {
      pageTitle: 'Create Requisition',
      breadcrumbs: ['Requisitions', 'Create']
    }
  },
  {
    path: '/purchasing/requisitions/:id/edit',
    name: 'requisitions.edit',
    component: () => import('@/modules/purchasing/requisitions/views/RequisitionsEdit.vue'),
    meta: {
      pageTitle: 'Edit Requisition',
      breadcrumbs: ['Requisitions', 'Edit']
    }
  },
  {
    path: '/purchasing/requisitions/:id/create-purchase-order',
    name: 'requisitions.create-purchase-order',
    component: () =>
      import('@/modules/purchasing/requisitions/views/RequisitionCreatePurchaseOrder.vue'),
    meta: {
      pageTitle: 'Create Purchase Order from Requisition',
      breadcrumbs: ['Requisitions', 'Create Purchase Order']
    }
  }
]

export default requisitionsRoutes
